;(function($) {
    if (typeof $.fn.tooltip === 'undefined') {
        throw new Error('Bootstrap Tooltip must be included first!');
    }

    // Bootstrap 4 alpha may not expose Constructor directly
    var Tooltip = $.fn.tooltip.Constructor || $.fn.tooltip;

    if (typeof Tooltip.Default !== 'undefined') {
        // add customClass option to Bootstrap Tooltip
        $.extend(Tooltip.Default, {
            customClass: ''
        });

        var _show = Tooltip.prototype.show;
        Tooltip.prototype.show = function () {
            _show.apply(this, Array.prototype.slice.apply(arguments));
            if (this.config.customClass) {
                var tip = this.getTipElement();
                $(tip).addClass(this.config.customClass);
            }
        };
    }
})(window.jQuery);
